// import { ex } from "@fullcalendar/core/internal-common";

export default [
  {
    id: 0,
    name: "Dr. Nikhil Goyal",
    group: "IP Consultation",
  },
  {
    id: 1,
    name: "Dr. Mukta Datta",
    group: "IP Consultation",
  },
  {
    id: 2,
    name: "Sodium",
    group: "Biochemistry",
  },
  {
    id: 3,
    name: "Critical Care Team",
    group: "IP Consultation",
  },
  {
    id: 4,
    name: "Covid Test",
    group: "Diagnosis",
  },
];

const medicines = [
  {
    id: "med1",
    name: "Pacimol 650",
    group: "IP Consultation",
    batch: "batch1",
    expiry: "2024-04-12",
    unit: [
      { id: "unit1", name: "Piece" },
      { id: "unit2", name: "10s" },
    ],
    stock: 10,
    cost: 75,
    mrp: 115,
    rate: 100,
    gst: 18,
    taxable: 0,
    gstAmount: 0,
    discount: 0,
    discountAmount: 0,
    subtotal: 0,
    quantity: "",
  },
  {
    id: "med2",
    name: "Calpol Syrup 120",
    group: "IP Consultation",
    batch: "batch1",
    expiry: "2024-04-12",
    unit: [
      { id: "unit1", name: "Piece" },
      { id: "unit2", name: "10s" },
    ],
    stock: 10,
    cost: 75,
    mrp: 115,
    rate: 100,
    gst: 18,
    taxable: 0,
    gstAmount: 0,
    discount: 0,
    discountAmount: 0,
    subtotal: 0,
    quantity: "",
  },
  {
    id: "med3",
    name: "Calcium Lactate",
    group: "IP Consultation",
    batch: "batch1",
    expiry: "2024-04-12",
    unit: [
      { id: "unit1", name: "Piece" },
      { id: "unit2", name: "10s" },
    ],
    stock: 10,
    cost: 75,
    mrp: 115,
    rate: 100,
    gst: 18,
    taxable: 0,
    gstAmount: 0,
    discount: 0,
    discountAmount: 0,
    subtotal: 0,
    quantity: "",
  },
  {
    id: "med4",
    name: "Survoline",
    group: "IP Consultation",
    batch: "batch1",
    expiry: "2024-04-12",
    unit: [
      { id: "unit1", name: "Piece" },
      { id: "unit2", name: "10s" },
    ],
    stock: 10,
    cost: 75,
    mrp: 115,
    rate: 100,
    gst: 18,
    taxable: 0,
    gstAmount: 0,
    discount: 0,
    discountAmount: 0,
    subtotal: 0,
    quantity: "",
  },
  {
    id: "med5",
    name: "Azithromycin",
    group: "IP Consultation",
    batch: "batch1",
    expiry: "2024-04-12",
    unit: [
      { id: "unit1", name: "Piece" },
      { id: "unit2", name: "10s" },
    ],
    stock: 10,
    cost: 75,
    mrp: 115,
    rate: 100,
    gst: 18,
    taxable: 0,
    gstAmount: 0,
    discount: 0,
    discountAmount: 0,
    subtotal: 0,
    quantity: "",
  },
];

// export { medicines };

const symptoms = [
  { name: "Hemoglobin", type: "tests" },
  { name: "TSH", type: "tests" },
  { name: "Stool", type: "tests" },
  { name: "ECG", type: "tests" },
  { name: "USG", type: "tests" },
  { name: "MRI", type: "tests" },
];

// export { symptoms };

const surgery = [
  { name: "Bypass", type: "surgery" },
  { name: "Gall Bladder", type: "surgery" },
  { name: "C-Section", type: "surgery" },
  { name: "Open Hurt Surgery", type: "surgery" },
  { name: "Lasik Surgery", type: "surgery" },
  { name: "Appendics Surgery", type: "surgery" },
];

// export { surgery };

const therapy = [
  { name: "Bypass", type: "therapy" },
  { name: "Gall Bladder", type: "therapy" },
  { name: "C-Section", type: "therapy" },
  { name: "Open Hurt therapy", type: "therapy" },
  { name: "Lasik therapy", type: "therapy" },
  { name: "Appendics therapy", type: "therapy" },
];

// export { therapy };

const medics = [
  { name: "Paracetamol", type: "medicine" },
  { name: "Pacimol", type: "medicine" },
  { name: "Survolin", type: "medicine" },
  { name: "Metrogyl", type: "medicine" },
  { name: "Eno", type: "medicine" },
  { name: "Altroxin", type: "medicine" },
  { name: "Hemoglobin", type: "tests" },
  { name: "TSH", type: "tests" },
  { name: "Stool", type: "tests" },
  { name: "ECG", type: "tests" },
  { name: "USG", type: "tests" },
  { name: "MRI", type: "tests" },
];
// export { medics };

const serviceMaster = [
  {
    id: 0,
    name: "Dr. Nikhil Goyal",
    group: "IP Consultation",
  },
  {
    id: 1,
    name: "Dr. Mukta Datta",
    group: "IP Consultation",
  },
  {
    id: 2,
    name: "Sodium",
    group: "Biochemistry",
  },
  {
    id: 3,
    name: "Critical Care Team",
    group: "IP Consultation",
  },
  {
    id: 4,
    name: "Covid Test",
    group: "Diagnosis",
  },
];

// export { serviceMaster };

const posd = [
  {
    id: "rec6d6T3q5EBIdCfD",
    name: "Gen. Medicine",
    image: "https://www.course-api.com/images/tours/tour-1.jpeg",
    price: "1,995",
  },
  {
    id: "recIwxrvU9HfJR3B4",
    name: "Gen. Surgery",
    image: "https://www.course-api.com/images/tours/tour-2.jpeg",
    price: "3,895",
  },
  {
    id: "recJLWcHScdUtI3ny",
    name: "Orthopedic",
    image: "https://www.course-api.com/images/tours/tour-3.jpeg",
    price: "2,695",
  },
  {
    id: "recK2AOoVhIHPLUwn",
    name: "Gynecology	",
    image: "https://www.course-api.com/images/tours/tour-4.jpeg",
    price: "2,095",
  },
  {
    id: "receAEzz86KzW2gvH",
    name: "Pediatric",
    image: "https://www.course-api.com/images/tours/tour-5.jpeg",
    price: "2,595",
  },
];

// export { posd };

const specilization = [
  {
    id: "rec6d6T3q5EBIdCfD",
    name: "Dermatology",
    image: "https://www.course-api.com/images/tours/tour-1.jpeg",
    price: "1,995",
  },
  {
    id: "recIwxrvU9HfJR3B4",
    name: "Ophthalmology",
    image: "https://www.course-api.com/images/tours/tour-2.jpeg",
    price: "3,895",
  },
  {
    id: "recJLWcHScdUtI3ny",
    name: "Oncology",
    image: "https://www.course-api.com/images/tours/tour-3.jpeg",
    price: "2,695",
  },
  {
    id: "recK2AOoVhIHPLUwn",
    name: "ENT",
    image: "https://www.course-api.com/images/tours/tour-4.jpeg",
    price: "2,095",
  },
  {
    id: "receAEzz86KzW2gvH",
    name: "Consultant WorkBench",
    image: "https://www.course-api.com/images/tours/tour-5.jpeg",
    price: "2,595",
  },
];

// export { specilization };
const apiEndPoint = "http://localhost/phpapi/index.php/api/";
const suggestionUrl = "/ServiceAllocation/searchService/";
const erxProps = [
  // symptomProps:
  {
    adviceType: "Symptoms",
    variant: "primary",
    id: "symptom",
    dataSource: suggestionUrl + "?advice=symptoms&",
    adviceSubmitUrl: "/patient/new-advice/",
    typeaheadId: "symptomsearchbar",
    fields: [
      {
        label: "Detail",
        props: { as: "textarea", rows: 1 },
        ref: "detail",
      },
    ],
  },
  // diagnosisProps:
  {
    adviceType: "Diagnostic",
    variant: "success",
    id: "diagnosis",
    dataSource: suggestionUrl + "?advice=diagnostic&",
    adviceSubmitUrl: "/patient/new-advice/",
    typeaheadId: "diagnosisearchbar",
    fields: [
      {
        label: "Remarks",
        props: { as: "textarea", rows: 1 },
        ref: "remark",
      },
      {
        label: "Detail",
        props: { as: "textarea", rows: 1 },
        ref: "detail",
      },
    ],
  },
  // surgeryProps:
  {
    adviceType: "Surgical Procedure",
    variant: "danger",
    id: "surgical",
    dataSource: suggestionUrl + "?advice=surgical&",
    adviceSubmitUrl: "/patient/new-advice/",
    typeaheadId: "surgerysearchbar",
    // extraReferences: [dateRef],
    fields: [
      {
        label: "Adviced Date",
        props: { as: "input", type: "date", required: true },
        ref: "advicedDate",
      },
      {
        label: "Performed Date",
        props: { as: "input", type: "date", required: true },
        ref: "performedDate",
        hidden: true,
      },
      {
        label: "Remarks",
        props: { as: "textarea", rows: 1 },
        ref: "remark",
      },
    ],
  },
  // therapyProps:
  {
    adviceType: "Therapetic Procedure",
    variant: "secondary",
    id: "therapatic",
    dataSource: suggestionUrl + "?advice=therapetic&",
    adviceSubmitUrl: "/patient/new-advice/",
    typeaheadId: "therapysearchbar",
    // extraReferences: [dateRef],
    fields: [
      {
        label: "From Date",
        props: { as: "input", type: "date", required: true },
        ref: "advicedFromDate",
      },
      {
        label: "To Date",
        props: { as: "input", type: "date", required: true },
        ref: "advicedToDate",
      },
      {
        label: "Frequency",
        props: { as: "input", required: true },
        ref: "advicedFrequency",
      },
      {
        label: "From Date",
        props: { as: "input", type: "date", required: true },
        ref: "performedFromDate",
      },
      {
        label: "To Date",
        props: { as: "input", type: "date", required: true },
        ref: "performedToDate",
      },
      {
        label: "Frequency",
        props: { as: "input", required: true },
        ref: "performedFrequency",
      },
      {
        label: "Remarks",
        props: { as: "textarea", rows: 1 },
        ref: "remark",
      },
    ],
    thGroups: [
      {
        label: "",
        colspan: 1,
      },
      {
        label: "Adviced",
        colspan: 3,
      },
      {
        label: "Performed",
        colspan: 3,
      },
      {
        label: "",
        colspan: 1,
      },
    ],
  },
  // medicProps:
  {
    adviceType: "Medication",
    variant: "primary",
    id: "medication",
    dataSource: suggestionUrl + "?advice=medication&",
    adviceSubmitUrl: "/patient/new-advice/",
    typeaheadId: "medicinesearchbar",
    // extraReferences: [dateRef],
    fields: [
      {
        label: "Timing",
        controlType: "select",
        props: { required: true },
        data: [
          {
            label: "AC",
            value: "ac",
          },
          {
            label: "PC",
            value: "pc",
          },
        ],
        ref: "timing",
      },
      {
        label: "Frequency",
        props: { as: "input", required: true },
        ref: "frequency",
      },
      {
        label: "Dosage",
        props: { as: "input", type: "text", required: true },
        ref: "dosage",
      },
      {
        label: "Duration",
        props: { as: "input", type: "text", required: true },
        ref: "duration",
        hidden: true,
      },
      {
        label: "Remarks",
        props: { as: "textarea", rows: 1 },
        ref: "remarks",
      },
      {
        label: "Allergy",
        controlType: "check",
        props: { type: "checkbox", label: "Yes" },
        ref: "allergy",
      },
    ],
  },
  // allergyProps:
  {
    adviceType: "Allergy",
    variant: "info",
    id: "allergy",
    dataSource: suggestionUrl + "?advice=allergy&",
    adviceSubmitUrl: "/patient/new-advice/",
    typeaheadId: "allergysearchbar",
    // extraReferences: [dateRef],
    fields: [
      {
        label: "Frequency",
        props: { as: "input", required: true },
        ref: "frequency",
      },
      {
        label: "First Identified On",
        props: { as: "input", type: "date", required: true },
        ref: "firstIdentified",
      },
      {
        label: "Description",
        props: { as: "textarea", rows: 1 },
        ref: "description",
      },
    ],
  },
  // dietProps:
  {
    adviceType: "Diet and Nutrition",
    variant: "dark",
    id: "diet-nutrition",
    dataSource: suggestionUrl + "?advice=diet&",
    adviceSubmitUrl: "/patient/new-advice/",
    typeaheadId: "dietsearchbar",
    // extraReferences: [dateRef],
    fields: [
      {
        label: "Description",
        props: { as: "textarea", rows: 1 },
        ref: "description",
      },
    ],
  },
];
const calendarEvents = [
  // {
  //   month: null,
  //   date: null,
  //   week_day: 1,
  //   start_time: "10:00:00",
  //   end_time: "12:00:00",
  //   effective_from_date: "2023-12-19",
  //   effective_to_date: "2024-12-19",
  //   max_booking: 1,
  //   activity_id: 1,
  //   activity_schedule_id: 1,
  //   // booking_count: 0,
  // },
  {
    month: null,
    date: null,
    week_day: 1,
    start_time: "10:00:00",
    end_time: "12:00:00",
    effective_from_date: "2023-12-19",
    effective_to_date: "2030-03-15",
    max_booking: 1,
    bp_br_activity_id: 1,
    bp_br_activity_schedule_id: 1,
    title: "Dr. Ramaswamy",
    borderColor: "gray",
    backgroundColor: "lightgray",
    textColor: "black",
  },
  // {
  //   month: null,
  //   date: null,
  //   week_day: 1,
  //   start_time: "17:00:00",
  //   end_time: "19:00:00",
  //   effective_from_date: "2023-12-19",
  //   effective_to_date: "2030-03-15",
  //   max_booking: 1,
  //   activity_id: 1,
  //   activity_schedule_id: 1,
  //   // editable: true,
  // },
];

export {
  calendarEvents,
  medicines,
  symptoms,
  surgery,
  therapy,
  medics,
  serviceMaster,
  posd,
  specilization,
  erxProps,
};
// export data;
